import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './hooks/auth/AuthContext';
import { LayoutProvider } from './hooks/layout/LayoutContext';
import { ApolloProvider } from '@apollo/client';
import { CookiesProvider } from 'react-cookie';
import { client } from './apollo-clients';

ReactDOM.render(
  // <React.StrictMode>
  <CookiesProvider>
    <LayoutProvider>
      <ApolloProvider client={client}>
        <AuthProvider>
          <App />
        </AuthProvider>
      </ApolloProvider>
    </LayoutProvider>
  </CookiesProvider>,
  // </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
